var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuySell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2326_12971)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3417 12.8359C19.4957 12.8359 22.8632 11.3392 22.8632 9.493C22.8632 7.64679 19.4957 6.15015 15.3417 6.15015C11.1878 6.15015 7.82031 7.64679 7.82031 9.493C7.82031 11.3392 11.1878 12.8359 15.3417 12.8359Z",
    stroke: "#6D6584",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.82031 9.49292V19.5215C7.82031 21.3601 11.1632 22.8643 15.3417 22.8643C19.5203 22.8643 22.8632 21.3601 22.8632 19.5215V9.49292",
    stroke: "#6D6584",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8632 14.5071C22.8632 16.3457 19.5203 17.8499 15.3417 17.8499C11.1632 17.8499 7.82031 16.3457 7.82031 14.5071",
    stroke: "#6D6584",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1748 2.82185C13.2217 1.61653 10.9483 1.03361 8.65619 1.15041C4.49434 1.15041 1.13477 2.6547 1.13477 4.49328C1.13477 5.47942 2.10419 6.36528 3.64191 7.00042",
    stroke: "#6D6584",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.64191 17.0291C2.10419 16.394 1.13477 15.5081 1.13477 14.522V4.49341",
    stroke: "#6D6584",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.64191 12.0147C2.10419 11.3796 1.13477 10.4937 1.13477 9.50757",
    stroke: "#6D6584",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2326_12971"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuySell);
export default __webpack_public_path__ + "static/media/buySell.a53a8707aeea4fd2a96a4a5bf3343995.svg";
export { ForwardRef as ReactComponent };